export const LoadingScreen = ({ message }: { message?: string }) => (
  <div className="loading-screen">
    <div className="loader">
      <img src="/images/logo.png" height="128" alt="Loading icon" />
      <div className="message">{message}</div>
    </div>
  </div>
);
